$(document).ready(function () {
	$(".rkStep1 .leftBlock").html('<label>Length (m)</label> <input type="number" id="rkLength" />');
	$(".rkStep1 .rightBlock").html('<label>Width (m)</label> <input type="number" id="rkWidth" />');
	if ($(".rkStep1").length) {
		$("#myrkModal").hide();
		$(".shipping-bar").hide();
		$(".site-header").hide();
		$("#shopify-section-footer").hide()
	}
	$(".sEdge").click(function () {
		$("#myrkModal").show();
		var id = $(this).attr("id");
		$(".rkModal-footer").html(id)
	});
	$(".close").click(function () {
		$("#myrkModal").hide()
	});
	$(".rkEdge").click(function () {
		var id = $(".rkModal-footer").html(),
			image = $(this).find(".choose-edge .thumb").attr("src"),
			variant = $(this).find(".choose-edge").attr("id");
		jQuery.getJSON("/products/fibreglass-edging-trims-8-99-free-delivery-if-ordered-with-a-roofing-kit.js", function (product) {
			if ("19834260998" == variant) var trimprice = new Number(product.variants[0].price) / 100,
				edge = product.variants[0].title;
			else if ("19834261126" == variant) var trimprice = new Number(product.variants[2].price) / 100,
				edge = product.variants[2].title;
			else if ("19834261254" == variant) var trimprice = new Number(product.variants[4].price) / 100,
				edge = product.variants[4].title;
			else if ("19834261062" == variant) var trimprice = new Number(product.variants[1].price) / 100,
				edge = product.variants[1].title;
			else if ("19834261190" == variant) var trimprice = new Number(product.variants[3].price) / 100,
				edge = product.variants[3].title;
			else if ("19834261318" == variant) var trimprice = new Number(product.variants[5].price) / 100,
				edge = product.variants[5].title;
			else if ("19834261382" == variant) var trimprice = new Number(product.variants[6].price) / 100,
				edge = product.variants[6].title,
				leadprice = new Number(product.variants[7].price) / 100,
				leadid = product.variants[7].id,
				leadtitle = product.variants[7].title;
			else var trimprice = new Number(0),
				edge = "Own Trims";
			"19834261382" == variant ? $("#" + id + ".sEdge").html('<img src="' + image + '" value="' + trimprice + '" id="' + variant + '" title="' + edge + '" class="rkThumb" data-lead-value="' + leadprice + '" data-lead-id="' + leadid + '" data-lead-title="' + leadtitle + '" />') : $("#" + id + ".sEdge").html('<img src="' + image + '" value="' + trimprice + '" id="' + variant + '" title="' + edge + '" class="rkThumb" />');
			$("#myrkModal").hide()
		})
	});
	$(".rkButton1").click(function () {
		var length = $("#rkLength").val();
		if (length)
			if (length < 1) alert("Length has to be greater than zero");
			else {
				var width = $("#rkWidth").val();
				if (width)
					if (width < 1) alert("Width has to be greater than zero");
					else {
						var size = length * width;
						$(".rkLeft .sEdge:nth-of-type(1)").attr("data-dim", "Length");
						$(".rkLeft .sEdge:nth-of-type(1)").attr("data-meas", length);
						$(".rkLeft .sEdge:nth-of-type(1)").attr("data-side", "A");
						$(".rkLeft .sEdge:nth-of-type(2)").attr("data-dim", "Width");
						$(".rkLeft .sEdge:nth-of-type(2)").attr("data-meas", width);
						$(".rkLeft .sEdge:nth-of-type(2)").attr("data-side", "B");
						$(".rkRight .sEdge:nth-of-type(1)").attr("data-dim", "Width");
						$(".rkRight .sEdge:nth-of-type(1)").attr("data-meas", width);
						$(".rkRight .sEdge:nth-of-type(1)").attr("data-side", "C");
						$(".rkRight .sEdge:nth-of-type(2)").attr("data-dim", "Length");
						$(".rkRight .sEdge:nth-of-type(2)").attr("data-meas", length);
						$(".rkRight .sEdge:nth-of-type(2)").attr("data-side", "D");
						var m = size.toFixed(2);
						if (m <= 100) {
							$(".rkRoofSize").html('<span class="rkSM">' + m + "</span> m<sup>2</sup>");
							$(".rkStep1").hide();
							$("html, body").animate({
								scrollTop: $("h1:nth-child(1)").offset().top
							}, 100);
							$(".rkStep2").fadeIn(1200)
						}
						else {
							$(".rkStep1").hide();
							$("html, body").animate({
								scrollTop: $("h1:nth-child(1)").offset().top
							}, 100);
							$(".rkStep2").html('<h1>Call us on <span class="rkPhone">01803 523 689</span> for a quote</h1>\n<p>All roofs above 100m<sup>2</sup> need to be quoted over the phone.</p>\n<div class="rkButton5"><a href="/collections/all">CONTINUE BROWSING</a></div>');
							$(".rkStep2").fadeIn(1200)
						}
					}
				else alert("Width can't be empty")
			}
		else alert("Length can't be empty")
	});
	$(".rkButton2").click(function () {
      
            
      if($(".sEdge img").length < 4) {
        
        alert("Please selects trims for each side - if you don\'t need any trims for a particular side just select \"Own Trims\".");
        
      } else {
        
    
		$(".rkStep1").hide();
		$(".rkStep2").hide();
		$("html, body").animate({
			scrollTop: $("h1:nth-child(1)").offset().top
		}, 100);
		$(".rkStep3").fadeIn(1200);
		var num = $(".rkSM").html(),
			squareMetres = new Number(num),
			GRM = $("#rkGRM").val();
		"450" == GRM ? jQuery.getJSON("/products/grp-roofing-kits-450grm-dark-iron-grey.js", function (product) {
			var Tools = $("#rkTOOLS").val();
			if (squareMetres >= 0 && squareMetres <= 5) {
				sm = 5;
				if ("No" == Tools) var id = product.variants[0].id,
					price = product.variants[0].price;
				else var id = product.variants[10].id,
					price = product.variants[10].price
			}
			else if (squareMetres >= 6 && squareMetres <= 10) {
				sm = 10;
				if ("No" == Tools) var id = product.variants[1].id,
					price = product.variants[1].price;
				else var id = product.variants[11].id,
					price = product.variants[11].price
			}
			else if (squareMetres >= 11 && squareMetres <= 15) {
				sm = 15;
				if ("No" == Tools) var id = product.variants[2].id,
					price = product.variants[2].price;
				else var id = product.variants[12].id,
					price = product.variants[12].price
			}
			else if (squareMetres >= 16 && squareMetres <= 20) {
				sm = 20;
				if ("No" == Tools) var id = product.variants[3].id,
					price = product.variants[3].price;
				else var id = product.variants[13].id,
					price = product.variants[13].price
			}
			else if (squareMetres >= 21 && squareMetres <= 25) {
				sm = 25;
				if ("No" == Tools) var id = product.variants[4].id,
					price = product.variants[4].price;
				else var id = product.variants[14].id,
					price = product.variants[14].price
			}
			else if (squareMetres >= 26 && squareMetres <= 30) {
				sm = 30;
				if ("No" == Tools) var id = product.variants[5].id,
					price = product.variants[5].price;
				else var id = product.variants[15].id,
					price = product.variants[15].price
			}
			else if (squareMetres >= 31 && squareMetres <= 35) {
				sm = 35;
				if ("No" == Tools) var id = product.variants[6].id,
					price = product.variants[6].price;
				else var id = product.variants[16].id,
					price = product.variants[16].price
			}
			else if (squareMetres >= 36 && squareMetres <= 40) {
				sm = 40;
				if ("No" == Tools) var id = product.variants[7].id,
					price = product.variants[7].price;
				else var id = product.variants[17].id,
					price = product.variants[17].price
			}
			else if (squareMetres >= 41 && squareMetres <= 45) {
				sm = 45;
				if ("No" == Tools) var id = product.variants[8].id,
					price = product.variants[8].price;
				else var id = product.variants[18].id,
					price = product.variants[18].price
			}
			else if (squareMetres >= 46 && squareMetres <= 50) {
				sm = 50;
				if ("No" == Tools) var id = product.variants[9].id,
					price = product.variants[9].price;
				else var id = product.variants[19].id,
					price = product.variants[19].price
			}
			else if (squareMetres >= 51 && squareMetres <= 60) {
				sm = 60;
				if ("No" == Tools) var id = product.variants[20].id,
					price = product.variants[20].price;
				else var id = product.variants[25].id,
					price = product.variants[25].price
			}
			else if (squareMetres >= 61 && squareMetres <= 70) {
				sm = 70;
				if ("No" == Tools) var id = product.variants[21].id,
					price = product.variants[21].price;
				else var id = product.variants[26].id,
					price = product.variants[26].price
			}
			else if (squareMetres >= 71 && squareMetres <= 80) {
				sm = 80;
				if ("No" == Tools) var id = product.variants[22].id,
					price = product.variants[22].price;
				else var id = product.variants[27].id,
					price = product.variants[27].price
			}
			else if (squareMetres >= 81 && squareMetres <= 90) {
				sm = 90;
				if ("No" == Tools) var id = product.variants[23].id,
					price = product.variants[23].price;
				else var id = product.variants[28].id,
					price = product.variants[28].price
			}
			else if (squareMetres >= 91 && squareMetres <= 100) {
				var sm = 100;
				if ("No" == Tools) var id = product.variants[24].id,
					price = product.variants[24].price;
				else var id = product.variants[29].id,
					price = product.variants[29].price
			}
			var total = price / 100,
				SQM = $(".rk" + GRM + "GRM #" + sm + "m .option-details-content:nth-child(1)").html();
			$(".rkInfo").html('<div class="kit-option-details-content" value="' + total + '" id="' + id + '">\n</div>');
			$(".rkInfo #" + id).append(SQM);
			if ("No" == Tools);
			else {
				var ToolInfo = $(".rk" + GRM + "GRM #" + sm + "m .option-details-content:nth-of-type(2)").html();
				$(".rkInfo").append('<div class="rk-tool-option-details">\n</div>');
				$(".rk-tool-option-details").append(ToolInfo)
			}
			$(".rkInfo").append('<div class="trim-option-details">\n</div>');
			$(".trim-option-details").append("<p><b>Selected Edges/Trims:</b></p>\n");
			$(".trim-option-details").append('<ul class="rkEdgeUL">\n</ul>');
			$(".sEdge").each(function (index) {
				var dim = $(this).attr("data-dim"),
					id = $(this).find("img").attr("id"),
					trim = $(this).find("img").attr("title"),
					meas = new Number($(this).attr("data-meas")),
					side = $(this).attr("data-side");
           
				if ("Own Trims" == trim)
                  
                  $("ul.rkEdgeUL").append('<li class="rkEdgeLI" id="' + id + '" data-price="0" data-qty="0"><b>Roof Side ' + side + " (" + dim + ": " + meas + "m):</b><br>" + trim + "</li>");
			                  
                  else if (trim.indexOf("D260 Wall Flashing") >= 0) {
              
					var edgeTotalPrice = (edgePrice = new Number($(this).find("img").attr("value"))) * (qty = Math.ceil(meas / 3)),
						ledgePrice = new Number($(this).find("img").attr("value")),
						lqty = Math.ceil(meas / 3),
						ledgeTotalPrice = ledgePrice * lqty;
					$("ul.rkEdgeUL").append('<li class="rkEdgeLI" id="' + id + '" data-price="' + edgeTotalPrice + '" data-qty="' + qty + '"><b>Roof Side ' + side + " (" + dim + ": " + meas + "m):</b><br>" + trim + " (3m) x " + qty + "</li>");
					var LeadId = $(this).find("img").attr("data-lead-id"),
						LeadTitle = $(this).find("img").attr("data-lead-title");
                    //data-price below used to be var ledgeTotalPrice
					$("ul.rkEdgeUL").append('<li class="rkEdgeLI" id="' + LeadId + '" data-price="' + ledgeTotalPrice + '" data-qty="' + lqty + '">' + LeadTitle + " (3m) x " + lqty + "</li>")
	
                  }
				else {
					var edgePrice = new Number($(this).find("img").attr("value")),
						qty = Math.ceil(meas / 3),
						edgeTotalPrice = edgePrice * qty;
					$("ul.rkEdgeUL").append('<li class="rkEdgeLI" id="' + id + '" data-price="' + edgeTotalPrice + '" data-qty="' + qty + '"><b>Roof Side ' + side + " (" + dim + ": " + meas + "m):</b><br>" + trim + " (3m) x " + qty + "</li>")
				}
			});
			$(".rkStep3 h1").html('Your Kit will be <span class="rkPound">&pound;</span><span class="rkTotalPrice">0</span>');
			$(".rkInfo .kit-option-details-content").each(function (index) {
				var Total = new Number($(".rkTotalPrice").html()),
					grandTotal = (grandTotal = new Number($(this).attr("value")) + Total).toFixed(2);
				$(".rkTotalPrice").html(grandTotal)
			});
			$(".rkEdgeLI").each(function (index) {
				var Total = new Number($(".rkTotalPrice").html()),
					grandTotal = (grandTotal = new Number($(this).attr("data-price")) + Total).toFixed(2);
				$(".rkTotalPrice").html(grandTotal)
			})
		}) : jQuery.getJSON("/products/grp-roofing-kits-dark-iron-grey.js", function (product) {
			var Tools = $("#rkTOOLS").val();
			if (squareMetres >= 0 && squareMetres <= 5) {
				sm = 5;
				if ("No" == Tools) var id = product.variants[0].id,
					price = product.variants[0].price;
				else var id = product.variants[15].id,
					price = product.variants[15].price
			}
			else if (squareMetres >= 6 && squareMetres <= 10) {
				sm = 10;
				if ("No" == Tools) var id = product.variants[1].id,
					price = product.variants[1].price;
				else var id = product.variants[16].id,
					price = product.variants[16].price
			}
			else if (squareMetres >= 11 && squareMetres <= 15) {
				sm = 15;
				if ("No" == Tools) var id = product.variants[2].id,
					price = product.variants[2].price;
				else var id = product.variants[17].id,
					price = product.variants[17].price
			}
			else if (squareMetres >= 16 && squareMetres <= 20) {
				sm = 20;
				if ("No" == Tools) var id = product.variants[3].id,
					price = product.variants[3].price;
				else var id = product.variants[18].id,
					price = product.variants[18].price
			}
			else if (squareMetres >= 21 && squareMetres <= 25) {
				sm = 25;
				if ("No" == Tools) var id = product.variants[4].id,
					price = product.variants[4].price;
				else var id = product.variants[19].id,
					price = product.variants[19].price
			}
			else if (squareMetres >= 26 && squareMetres <= 30) {
				sm = 30;
				if ("No" == Tools) var id = product.variants[5].id,
					price = product.variants[5].price;
				else var id = product.variants[20].id,
					price = product.variants[20].price
			}
			else if (squareMetres >= 31 && squareMetres <= 35) {
				sm = 35;
				if ("No" == Tools) var id = product.variants[6].id,
					price = product.variants[6].price;
				else var id = product.variants[21].id,
					price = product.variants[21].price
			}
			else if (squareMetres >= 36 && squareMetres <= 40) {
				sm = 40;
				if ("No" == Tools) var id = product.variants[7].id,
					price = product.variants[7].price;
				else var id = product.variants[22].id,
					price = product.variants[22].price
			}
			else if (squareMetres >= 41 && squareMetres <= 45) {
				sm = 45;
				if ("No" == Tools) var id = product.variants[8].id,
					price = product.variants[8].price;
				else var id = product.variants[23].id,
					price = product.variants[23].price
			}
			else if (squareMetres >= 46 && squareMetres <= 50) {
				sm = 50;
				if ("No" == Tools) var id = product.variants[9].id,
					price = product.variants[9].price;
				else var id = product.variants[24].id,
					price = product.variants[24].price
			}
			else if (squareMetres >= 51 && squareMetres <= 60) {
				sm = 60;
				if ("No" == Tools) var id = product.variants[10].id,
					price = product.variants[10].price;
				else var id = product.variants[25].id,
					price = product.variants[25].price
			}
			else if (squareMetres >= 61 && squareMetres <= 70) {
				sm = 70;
				if ("No" == Tools) var id = product.variants[11].id,
					price = product.variants[11].price;
				else var id = product.variants[26].id,
					price = product.variants[26].price
			}
			else if (squareMetres >= 71 && squareMetres <= 80) {
				sm = 80;
				if ("No" == Tools) var id = product.variants[12].id,
					price = product.variants[12].price;
				else var id = product.variants[27].id,
					price = product.variants[27].price
			}
			else if (squareMetres >= 81 && squareMetres <= 90) {
				sm = 90;
				if ("No" == Tools) var id = product.variants[13].id,
					price = product.variants[13].price;
				else var id = product.variants[28].id,
					price = product.variants[28].price
			}
			else if (squareMetres >= 91 && squareMetres <= 100) {
				var sm = 100;
				if ("No" == Tools) var id = product.variants[14].id,
					price = product.variants[14].price;
				else var id = product.variants[29].id,
					price = product.variants[29].price
			}
			var total = price / 100,
				SQM = $(".rk" + GRM + "GRM #" + sm + "m .option-details-content:nth-child(1)").html();
			$(".rkInfo").html('<div class="kit-option-details-content" value="' + total + '" id="' + id + '">\n</div>');
			$(".rkInfo #" + id).append(SQM);
			if ("No" == Tools);
			else {
				var ToolInfo = $(".rk" + GRM + "GRM #" + sm + "m .option-details-content:nth-of-type(2)").html();
				$(".rkInfo").append('<div class="rk-tool-option-details">\n</div>');
				$(".rk-tool-option-details").append(ToolInfo)
			}
			$(".rkInfo").append('<div class="trim-option-details">\n</div>');
			$(".trim-option-details").append("<p><b>Selected Edges/Trims:</b></p>\n");
			$(".trim-option-details").append('<ul class="rkEdgeUL">\n</ul>');
			$(".sEdge").each(function (index) {
				var dim = $(this).attr("data-dim"),
					id = $(this).find("img").attr("id"),
					trim = $(this).find("img").attr("title"),
					meas = new Number($(this).attr("data-meas")),
					side = $(this).attr("data-side");
					
				
				if ("Own Trims" == trim)
			
				$("ul.rkEdgeUL").append('<li class="rkEdgeLI" id="' + id + '" data-price="0" data-qty="0"><b>Roof Side ' + side + " (" + dim + ": " + meas + "m):</b><br>" + trim + "</li>");
				 else if (trim.indexOf("D260 Wall Flashing") >= 0) {
					var edgeTotalPrice = (edgePrice = new Number($(this).find("img").attr("value"))) * (qty = Math.ceil(meas / 3)),
						ledgePrice = new Number($(this).find("img").attr("value")),
						lqty = Math.ceil(meas / 3),
						ledgeTotalPrice = ledgePrice * lqty;
					$("ul.rkEdgeUL").append('<li class="rkEdgeLI" id="' + id + '" data-price="' + edgeTotalPrice + '" data-qty="' + qty + '"><b>Roof Side ' + side + " (" + dim + ": " + meas + "m):</b><br>" + trim + " (3m) x " + qty + "</li>");
					var LeadId = $(this).find("img").attr("data-lead-id"),
						LeadTitle = $(this).find("img").attr("data-lead-title");
					$("ul.rkEdgeUL").append('<li class="rkEdgeLI" id="' + LeadId + '" data-price="' + ledgeTotalPrice + '" data-qty="' + lqty + '">' + LeadTitle + " (3m) x " + lqty + "</li>")
				 //$("ul.rkEdgeUL").append("<li class=\"rkEdgeLI\" id=\"768814879\" data-price=\"11.00\" data-qty=\"" + lqty + "\">C100 Simulated Lead Flashing (3m) x " + lqty + "</li>")
                
				
				}
				else {
					var edgePrice = new Number($(this).find("img").attr("value")),
						qty = Math.ceil(meas / 3),
						edgeTotalPrice = edgePrice * qty;
					$("ul.rkEdgeUL").append('<li class="rkEdgeLI" id="' + id + '" data-price="' + edgeTotalPrice + '" data-qty="' + qty + '"><b>Roof Side ' + side + " (" + dim + ": " + meas + "m):</b><br>" + trim + " (3m) x " + qty + "</li>")
				}
			});
			$(".rkStep3 h1").html('Your Kit will be <span class="rkPound">&pound;</span><span class="rkTotalPrice">0</span>');
			$(".rkInfo .kit-option-details-content").each(function (index) {
				var Total = new Number($(".rkTotalPrice").html()),
					grandTotal = (grandTotal = new Number($(this).attr("value")) + Total).toFixed(2);
				$(".rkTotalPrice").html(grandTotal)
			});
			$(".rkEdgeLI").each(function (index) {
				var Total = new Number($(".rkTotalPrice").html()),
					grandTotal = (grandTotal = new Number($(this).attr("data-price")) + Total).toFixed(2);
				$(".rkTotalPrice").html(grandTotal)
			})
		})
    } // TRIMS SELECTED LESS THAN 4 END IF
	});
	$(".rkButton3").click(function () {
		$(".rkBackButton2").hide();
		$(".rkStep3 h1").hide();
		$(".rkButton3").hide();
		$(".rkInfo").hide();
		$("h1.small--text-center").hide();
		$(".rkStep3").append('<h1>Please Wait</h1>\n<img class="rkLoading" src="//cdn.shopify.com/s/files/1/0600/8557/files/tenor_large.gif?v=1509471017" />');
		push_to_queue($(".kit-option-details-content").attr("id"), 1, {}, Shopify.moveAlong);
		(function theLoop(ii) {
			setTimeout(function () {
				var vid = $("li.rkEdgeLI:nth-of-type(" + ii + ")").attr("id"),
					vqty = $("li.rkEdgeLI:nth-of-type(" + ii + ")").attr("data-qty");
				0 == vqty || push_to_queue(vid, vqty, {}, Shopify.moveAlong);
				--ii && theLoop(ii)
			}, 1e3)
		})(new Number($(".rkEdge").length))
	});
	Shopify.queue = [];
	Shopify.moveAlong = function () {
		if (Shopify.queue.length) {
			var request = Shopify.queue.shift();
			Shopify.addItem(request.variantId, request.quantity, request.properties, Shopify.moveAlong)
		}
		else(function theLoop(i) {
			setTimeout(function () {
				--i ? theLoop(i) : loadCart()
			}, 1500)
		})(5)
	};
	Shopify.addItem = function (id, qty, properties, callback) {
		var params = {
			quantity: qty,
			id: id
		};
		0 != properties && (params.properties = properties);
		$.ajax({
			type: "POST",
			url: "/cart/add.js",
			dataType: "json",
			data: params,
			success: function () {
				"function" == typeof callback && callback()
			},
			error: function () {}
		})
	};

	function push_to_queue(variantID, quantity, properties, callback) {
		Shopify.queue.push({
			variantId: variantID,
			quantity: quantity,
			properties: properties
		});
		"function" == typeof callback && callback()
	}

	function loadCart() {
		$(".rkStep3").hide();
		$("html, body").animate({
			scrollTop: $("h1:nth-child(1)").offset().top
		}, 100);
		$(".rkStep4").fadeIn(1200)
	}
	$(".rkButtonCart").click(function () {
		document.location.href = "/cart"
	});
	$(".rkButtonCollections").click(function () {
		document.location.href = "/collections/all"
	});
	$(".rkBackButton1").click(function () {
		$(".rkStep3").hide();
		$(".rkStep2").hide();
		$("html, body").animate({
			scrollTop: $("h1:nth-child(1)").offset().top
		}, 100);
		$(".rkStep1").fadeIn(1200)
	});
	$(".rkBackButton2").click(function () {
		$(".rkStep1").hide();
		$(".rkStep3").hide();
		$("html, body").animate({
			scrollTop: $("h1:nth-child(1)").offset().top
		}, 100);
		$(".rkStep2").fadeIn(1200)
	})
});
